<template>

  <v-select 
    :value="selected"
    @input="change"
    :options="options"
    :placeholder="placeholder">
    </v-select>

</template>

<script>
import config from '../../config'

export default {
  name: 'SelectLocale',
  props: [
    'value',
    'placeholder'
  ],
  data () {
    return {
    }
  },
  computed: {
    options () {
      return config.locales
    },
    selected () {
      return this.options.find(val => {
        return val.value === this.value
      })
    }
  },
  created () {
  },
  methods: {
    change (val) {
      const value = val ? val.value : null
      if (value !== this.value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectLocale.vue